// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3SsIF","title":"Images45_title__2FDLa","images":"Images45_images__1Wu7t"};